<div *ngIf="dataNews" class="container-general-big d-flex justify-content-between p-2 no-print">
    <div class="container-general-big__container-image position-relative col-6">
        <img loading="lazy" *ngIf="dataNews.field_immagine" [src]="imgPath"
            class="container-general-big__container-image__image h-100 w-100" [alt]="image_alt">
        <div *ngIf="dataNews.field_tags"
            class="container-general-big__container-image__badge ls-label-small-semibold text-neutral-A1 bg-support-50 position-absolute top-0 left-0">
            {{dataNews.field_created_at | localizedDate: 'd MMMM yyyy'}}
        </div>
    </div>
    <div
        class="container-general-big__container-description bg-neutral-A1 col-6 d-flex flex-column justify-content-between">
        <div class="container-general-big__container-description__container-text">
            <div
                class="container-general-big__container-description__container-text__container-tags d-flex justify-content-between align-items-start">
                <div class="container-general-big__container-description__container-text__container-tags__tags">
                    <p class="text-neutral-60 ls-label-small-semibold m-0 text-uppercase" *ngIf="stringTaxonomies"
                        [innerHTML]="stringTaxonomies"></p>
                </div>
                <div class="container-general-big__container-description__container-text__container-tags__share"
                    (click)="openModaleShare()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
                </div>
            </div>
            <div class="container-general-big__container-description__container-text__text">
                <a *ngIf="objTitle && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                    <h3 class="text-brand-10 mb-3 text-decoration-none cursor-pointer" [hreflang]="objTitle.hreflang"
                        [innerHTML]="objTitle.title"></h3>
                </a>
                <a *ngIf="objTitle && isLinkEsternal" [href]="objTitle.link">
                    <h3 class="text-brand-10 mb-3 text-decoration-none cursor-pointer" [hreflang]="objTitle.hreflang"
                        [innerHTML]="objTitle.title"></h3>
                </a>
                <p *ngIf="dataNews.field_sottotitolo" class="text-neutral-40 ls-p-small"
                    [innerHTML]="dataNews.field_sottotitolo"></p>
            </div>
        </div>
        <a *ngIf="objTitle && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
            <div class="container-general-big__container-description__button-bottom">
                <div
                    class="m-0 ls-label-medium-semibold container-general-big__container-description__button-bottom__button text-brand-40 line-discover-with-icon">
                    <p class="ls-label-medium-semibold">{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
        <a *ngIf="objTitle && isLinkEsternal" [href]="objTitle.link">
            <div class="container-general-big__container-description__button-bottom">
                <div
                    class="m-0 ls-label-medium-semibold container-general-big__container-description__button-bottom__button text-brand-40 line-discover-with-icon">
                    <p class="ls-label-medium-semibold">{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
    </div>
</div>

<app-sample-print *ngIf="dataNews" [imageUrl]="dataNews.field_immagine ? imgPath : ''" [date]="dataNews.field_created_at" [title]="objTitle.title" [taxonomy]="stringTaxonomies"></app-sample-print>